// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_e0-0";